import { Dispatch } from "../store.config"
import axios from "axios"
import {
  PaCodeRoutage,
  CompanyWithoutPa,
  Customer,
  FormHistory,
  PaForm,
  SiretInfo,
  PaSuffixe,
  Executive,
  PaMaintenance,
  PA_DATE_START_BEFORE_MINIMAL,
} from "../../utils/pa"
import { AnyAction } from "redux"

const enum PaActionsEnum {
  GET_FIDUCIARY_PA_FORMS_ATTEMPT = "PA/getFiduciaryPaFormsAttempt",
  GET_FIDUCIARY_PA_FORMS_SUCCESS = "PA/getFiduciaryPaFormsSuccess",
  GET_FIDUCIARY_PA_FORMS_FAILURE = "PA/getFiduciaryPaFormsFailure",

  GET_SIRETS_AND_CUSTOMERS_OF_COMPANY_ATTEMPT = "PA/getSiretsAndCustomersOfCompanyAttempt",
  GET_SIRETS_AND_CUSTOMERS_OF_COMPANY_SUCCESS = "PA/getSiretsAndCustomersOfCompanySuccess",
  GET_SIRETS_AND_CUSTOMERS_OF_COMPANY_FAILURE = "PA/getSiretsAndCustomersOfCompanyFailure",

  SAVE_PA_FORM_ATTEMPT = "PA/SavePaFormAttempt",
  SAVE_PA_FORM_SUCCESS = "PA/SavePaFormSuccess",
  SAVE_PA_FORM_FAILURE = "PA/SavePaFormFailure",
  SAVE_PA_FORM_MINIMAL_DATE_START_CHANGED = "PA/SavePaFormMinimalDateStartChanged",

  RESET_FORM = "PA/resetForm",

  GET_PA_FORM_FOR_COMPANY_ATTEMPT = "PA/getPaFormForCompanyAttempt",
  GET_PA_FORM_FOR_COMPANY_SUCCESS = "PA/getPaFormForCompanySuccess",
  GET_PA_FORM_FOR_COMPANY_FAILURE = "PA/getPaFormForCompanyFailure",

  GET_COMPANIES_WITHOUT_PA_ATTEMPT = "PA/getCompaniesWithoutPaAttempt",
  GET_COMPANIES_WITHOUT_PA_SUCCESS = "PA/getCompaniesWithoutPaSuccess",
  GET_COMPANIES_WITHOUT_PA_FAILURE = "PA/getCompaniesWithoutPaFailure",

  GET_EXECUTIVES_FROM_PAPERS_ATTEMPT = "PA/getExecutivesFromPapersAttempt",
  GET_EXECUTIVES_FROM_PAPERS_SUCCESS = "PA/getExecutivesFromPapersSuccess",
  GET_EXECUTIVES_FROM_PAPERS_FAILURE = "PA/getExecutivesFromPapersFailure",

  GET_PA_MAINTENANCE_ATTEMPT = "PA/getPaMaintenanceAttempt",
  GET_PA_MAINTENANCE_SUCCESS = "PA/getPaMaintenanceSuccess",
  GET_PA_MAINTENANCE_FAILURE = "PA/getPaMaintenanceFailure",

  GET_PA_SUB_TOKEN_ATTEMPT = "PA/getPaSubTokenAttempt",
  GET_PA_SUB_TOKEN_SUCCESS = "PA/getPaSubTokenSuccess",
  GET_PA_SUB_TOKEN_FAILURE = "PA/getPaSubTokenFailure",

  CREATE_PA_SUB_TOKEN_ATTEMPT = "PA/createPaSubTokenAttempt",
  CREATE_PA_SUB_TOKEN_SUCCESS = "PA/createPaSubTokenSuccess",
  CREATE_PA_SUB_TOKEN_FAILURE = "PA/createPaSubTokenFailure",

  RECREATE_PA_SUB_TOKEN_ATTEMPT = "PA/recreatePaSubTokenAttempt",
  RECREATE_PA_SUB_TOKEN_SUCCESS = "PA/recreatePaSubTokenSuccess",
  RECREATE_PA_SUB_TOKEN_FAILURE = "PA/recreatePaSubTokenFailure",

  CLEAR_PA_SUB_TOKEN_SECRET = "PA/clearPaSubTokenSecret",

  RESEND_PA_SIGNATURE_ATTEMPT = "PA/resendPaSignatureAttempt",
  RESEND_PA_SIGNATURE_SUCCESS = "PA/resendPaSignatureSuccess",
  RESEND_PA_SIGNATURE_FAILURE = "PA/resendPaSignatureFailure",
}

export const getFiduciaryPaFormsAttempt = () =>
  ({ type: PaActionsEnum.GET_FIDUCIARY_PA_FORMS_ATTEMPT } as const)
export const getFiduciaryPaFormsSuccess = (paForms: PaForm[]) =>
  ({
    type: PaActionsEnum.GET_FIDUCIARY_PA_FORMS_SUCCESS,
    paForms,
  } as const)
export const getFiduciaryPaFormsFailure = () =>
  ({
    type: PaActionsEnum.GET_FIDUCIARY_PA_FORMS_FAILURE,
  } as const)

export const getSiretsAndCustomersOfCompanyAttempt = () =>
  ({
    type: PaActionsEnum.GET_SIRETS_AND_CUSTOMERS_OF_COMPANY_ATTEMPT,
  } as const)
export const getSiretsAndCustomersOfCompanySuccess = (
  siret_infos: SiretInfo[],
  customers: Customer[]
) =>
  ({
    type: PaActionsEnum.GET_SIRETS_AND_CUSTOMERS_OF_COMPANY_SUCCESS,
    siret_infos,
    customers,
  } as const)
export const getSiretsAndCustomersOfCompanyFailure = () =>
  ({
    type: PaActionsEnum.GET_SIRETS_AND_CUSTOMERS_OF_COMPANY_FAILURE,
  } as const)

export const SavePaFormAttempt = () =>
  ({
    type: PaActionsEnum.SAVE_PA_FORM_ATTEMPT,
  } as const)
export const SavePaFormSuccess = (draft: boolean) =>
  ({
    type: PaActionsEnum.SAVE_PA_FORM_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "dashboard-pa.create.success.title",
      bodyKey: `dashboard-pa.create.success.message${draft ? "-draft" : ""}`,
    },
  } as const)
export const SavePaFormFailure = (errorDetail: string) =>
  ({
    type: PaActionsEnum.SAVE_PA_FORM_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "dashboard-pa.create.error.title",
      bodyKey: "dashboard-pa.create.error.message-detail",
      bodyValues: {
        generic: "Le mandat ne peut pas être modifié dans ce statut",
        detail: String(errorDetail || ""),
      },
    },
    e: errorDetail,
  } as const)

// Refus J+9 : rien n'est enregistré, le front recale ses lignes sur la date du back.
export const SavePaFormMinimalDateStartChanged = (minimalDateStart: string) =>
  ({
    type: PaActionsEnum.SAVE_PA_FORM_MINIMAL_DATE_START_CHANGED,
    minimalDateStart,
  } as const)

export const getPaFormForCompanyAttempt = () =>
  ({
    type: PaActionsEnum.GET_PA_FORM_FOR_COMPANY_ATTEMPT,
  } as const)
export const getPaFormForCompanySuccess = (payload: {
  form_for_company: FormHistory
  company: CompanyWithoutPa
}) =>
  ({
    type: PaActionsEnum.GET_PA_FORM_FOR_COMPANY_SUCCESS,
    payload,
  } as const)
export const getPaFormForCompanyFailure = () =>
  ({
    type: PaActionsEnum.GET_PA_FORM_FOR_COMPANY_FAILURE,
  } as const)

export const resetForm = () =>
  ({
    type: PaActionsEnum.RESET_FORM,
  } as const)

export const getCompaniesWithoutPaAttempt = () =>
  ({
    type: PaActionsEnum.GET_COMPANIES_WITHOUT_PA_ATTEMPT,
  } as const)
export const getCompaniesWithoutPaSuccess = (
  companies_without_pa: CompanyWithoutPa[]
) =>
  ({
    type: PaActionsEnum.GET_COMPANIES_WITHOUT_PA_SUCCESS,
    companies_without_pa,
  } as const)
export const getCompaniesWithoutPaFailure = () =>
  ({
    type: PaActionsEnum.GET_COMPANIES_WITHOUT_PA_FAILURE,
  } as const)

export const getExecutivesFromPapersAttempt = () =>
  ({
    type: PaActionsEnum.GET_EXECUTIVES_FROM_PAPERS_ATTEMPT,
  } as const)
export const getExecutivesFromPapersSuccess = (executives: {
  accountant_executives: Executive[]
  customer_executives: Executive[]
}) =>
  ({
    type: PaActionsEnum.GET_EXECUTIVES_FROM_PAPERS_SUCCESS,
    payload: {
      accountant_executives: executives.accountant_executives,
      customer_executives: executives.customer_executives,
    },
  } as const)
export const getExecutivesFromPapersFailure = () =>
  ({
    type: PaActionsEnum.GET_EXECUTIVES_FROM_PAPERS_FAILURE,
  } as const)

export const getPaMaintenanceAttempt = () =>
  ({
    type: PaActionsEnum.GET_PA_MAINTENANCE_ATTEMPT,
  } as const)
export const getPaMaintenanceSuccess = (maintenance: PaMaintenance) =>
  ({
    type: PaActionsEnum.GET_PA_MAINTENANCE_SUCCESS,
    maintenance,
  } as const)

export const getPaMaintenanceFailure = () =>
  ({
    type: PaActionsEnum.GET_PA_MAINTENANCE_FAILURE,
  } as const)

export type PaSubTokenStatus = {
  client_id: string | null
  created: boolean
  declared_companies_count: number
}

export type PaSubTokenCredentials = {
  client_id: string
  client_secret: string
  declared_companies_count: number
}

export const getPaSubTokenAttempt = () =>
  ({ type: PaActionsEnum.GET_PA_SUB_TOKEN_ATTEMPT } as const)
export const getPaSubTokenSuccess = (subToken: PaSubTokenStatus) =>
  ({ type: PaActionsEnum.GET_PA_SUB_TOKEN_SUCCESS, subToken } as const)
export const getPaSubTokenFailure = () =>
  ({ type: PaActionsEnum.GET_PA_SUB_TOKEN_FAILURE } as const)

export const createPaSubTokenAttempt = () =>
  ({ type: PaActionsEnum.CREATE_PA_SUB_TOKEN_ATTEMPT } as const)
export const createPaSubTokenSuccess = (credentials: PaSubTokenCredentials) =>
  ({
    type: PaActionsEnum.CREATE_PA_SUB_TOKEN_SUCCESS,
    credentials,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary.pa.sub-token.create.success.title",
      bodyKey: "fiduciary.pa.sub-token.create.success.message",
    },
  } as const)
export const createPaSubTokenFailure = () =>
  ({
    type: PaActionsEnum.CREATE_PA_SUB_TOKEN_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary.pa.sub-token.create.error.title",
      bodyKey: "fiduciary.pa.sub-token.create.error.message",
    },
  } as const)

export const recreatePaSubTokenAttempt = () =>
  ({ type: PaActionsEnum.RECREATE_PA_SUB_TOKEN_ATTEMPT } as const)
export const recreatePaSubTokenSuccess = (credentials: PaSubTokenCredentials) =>
  ({
    type: PaActionsEnum.RECREATE_PA_SUB_TOKEN_SUCCESS,
    credentials,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary.pa.sub-token.recreate.success.title",
      bodyKey: "fiduciary.pa.sub-token.recreate.success.message",
    },
  } as const)
export const recreatePaSubTokenFailure = () =>
  ({
    type: PaActionsEnum.RECREATE_PA_SUB_TOKEN_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary.pa.sub-token.recreate.error.title",
      bodyKey: "fiduciary.pa.sub-token.recreate.error.message",
    },
  } as const)

export const clearPaSubTokenSecret = () =>
  ({ type: PaActionsEnum.CLEAR_PA_SUB_TOKEN_SECRET } as const)

export const resendPaSignatureAttempt = () =>
  ({ type: PaActionsEnum.RESEND_PA_SIGNATURE_ATTEMPT } as const)
export const resendPaSignatureSuccess = () =>
  ({
    type: PaActionsEnum.RESEND_PA_SIGNATURE_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary.pa.form-generated.resend-mail.success.title",
      bodyKey: "fiduciary.pa.form-generated.resend-mail.success.message",
    },
  } as const)
export const resendPaSignatureFailure = (errorDetail: string) =>
  ({
    type: PaActionsEnum.RESEND_PA_SIGNATURE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary.pa.form-generated.resend-mail.error.title",
      bodyKey: "fiduciary.pa.form-generated.resend-mail.error.message",
      bodyValues: {
        generic: "Le mandat ne peut pas être modifié dans ce statut",
        detail: String(errorDetail || ""),
      },
    },
    e: errorDetail,
  } as const)

export const createPaFormsInBulkSuccess = () =>
  ({
    type: "PA/createPaFormsInBulkSuccess",
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary.pa.multiple-connexion.create.success.title",
      bodyKey: "fiduciary.pa.multiple-connexion.create.success.message",
    },
  } as const)

type PaActionsType = ReturnType<
  | typeof getFiduciaryPaFormsAttempt
  | typeof getFiduciaryPaFormsSuccess
  | typeof getFiduciaryPaFormsFailure
  | typeof getSiretsAndCustomersOfCompanyAttempt
  | typeof getSiretsAndCustomersOfCompanySuccess
  | typeof getSiretsAndCustomersOfCompanyFailure
  | typeof SavePaFormAttempt
  | typeof SavePaFormSuccess
  | typeof SavePaFormFailure
  | typeof SavePaFormMinimalDateStartChanged
  | typeof getPaFormForCompanyAttempt
  | typeof getPaFormForCompanySuccess
  | typeof getPaFormForCompanyFailure
  | typeof resetForm
  | typeof getCompaniesWithoutPaAttempt
  | typeof getCompaniesWithoutPaSuccess
  | typeof getCompaniesWithoutPaFailure
  | typeof getExecutivesFromPapersAttempt
  | typeof getExecutivesFromPapersSuccess
  | typeof getExecutivesFromPapersFailure
  | typeof getPaMaintenanceAttempt
  | typeof getPaMaintenanceSuccess
  | typeof getPaMaintenanceFailure
  | typeof getPaSubTokenAttempt
  | typeof getPaSubTokenSuccess
  | typeof getPaSubTokenFailure
  | typeof createPaSubTokenAttempt
  | typeof createPaSubTokenSuccess
  | typeof createPaSubTokenFailure
  | typeof recreatePaSubTokenAttempt
  | typeof recreatePaSubTokenSuccess
  | typeof recreatePaSubTokenFailure
  | typeof clearPaSubTokenSecret
  | typeof resendPaSignatureAttempt
  | typeof resendPaSignatureSuccess
  | typeof resendPaSignatureFailure
>

export interface PaState {
  pa_forms: PaForm[]
  siret_infos: SiretInfo[]
  create_pa_form_status: "idle" | "loading" | "success" | "error"
  error_message: string
  form_for_company: FormHistory | null
  customers: Customer[]
  companies_without_pa: CompanyWithoutPa[]
  executives: {
    accountant_executives: Executive[]
    customer_executives: Executive[]
  }
  maintenance: PaMaintenance | null
  sub_token: PaSubTokenStatus | null
  sub_token_status: "idle" | "loading" | "success" | "error"
  sub_token_action_status: "idle" | "loading" | "success" | "error"
  sub_token_credentials: PaSubTokenCredentials | null
  resend_signature_status: "idle" | "loading" | "success" | "error"
}

export const PaInitialState: PaState = {
  pa_forms: [],
  siret_infos: [],
  create_pa_form_status: "idle",
  error_message: "",
  form_for_company: null,
  customers: [],
  companies_without_pa: [],
  executives: { accountant_executives: [], customer_executives: [] },
  maintenance: null,
  sub_token: null,
  sub_token_status: "idle",
  sub_token_action_status: "idle",
  sub_token_credentials: null,
  resend_signature_status: "idle",
}

export function PaReducer(
  state = PaInitialState,
  action: PaActionsType
): PaState {
  switch (action.type) {
    case PaActionsEnum.GET_FIDUCIARY_PA_FORMS_SUCCESS: {
      return {
        ...state,
        pa_forms: action.paForms,
        executives: { accountant_executives: [], customer_executives: [] },
      }
    }
    case PaActionsEnum.GET_SIRETS_AND_CUSTOMERS_OF_COMPANY_SUCCESS: {
      return {
        ...state,
        siret_infos: action.siret_infos,
        customers: action.customers,
      }
    }
    case PaActionsEnum.SAVE_PA_FORM_SUCCESS: {
      return { ...state, create_pa_form_status: "success", error_message: "" }
    }
    case PaActionsEnum.SAVE_PA_FORM_FAILURE: {
      return {
        ...state,
        create_pa_form_status: "error",
        error_message: String(action.e || ""),
      }
    }
    case PaActionsEnum.SAVE_PA_FORM_MINIMAL_DATE_START_CHANGED: {
      return {
        ...state,
        create_pa_form_status: "idle",
        error_message: "",
        companies_without_pa: state.companies_without_pa.map((c) => ({
          ...c,
          minimal_date_start: action.minimalDateStart,
        })),
      }
    }
    case PaActionsEnum.RESEND_PA_SIGNATURE_ATTEMPT: {
      return { ...state, resend_signature_status: "loading", error_message: "" }
    }
    case PaActionsEnum.RESEND_PA_SIGNATURE_SUCCESS: {
      return { ...state, resend_signature_status: "success", error_message: "" }
    }
    case PaActionsEnum.RESEND_PA_SIGNATURE_FAILURE: {
      return {
        ...state,
        resend_signature_status: "error",
        error_message: String(action.e || ""),
      }
    }
    case PaActionsEnum.SAVE_PA_FORM_ATTEMPT: {
      return { ...state, create_pa_form_status: "loading", error_message: "" }
    }
    case PaActionsEnum.GET_PA_FORM_FOR_COMPANY_SUCCESS: {
      return {
        ...state,
        form_for_company: action.payload.form_for_company,
        companies_without_pa: [action.payload.company],
      }
    }
    case PaActionsEnum.GET_PA_FORM_FOR_COMPANY_FAILURE: {
      return { ...state, form_for_company: null, companies_without_pa: [] }
    }
    case PaActionsEnum.RESET_FORM: {
      return {
        ...state,
        form_for_company: null,
        create_pa_form_status: "idle",
        resend_signature_status: "idle",
        error_message: "",
        siret_infos: [],
      }
    }
    case PaActionsEnum.GET_COMPANIES_WITHOUT_PA_ATTEMPT: {
      return { ...state, companies_without_pa: [] }
    }
    case PaActionsEnum.GET_COMPANIES_WITHOUT_PA_SUCCESS: {
      return { ...state, companies_without_pa: action.companies_without_pa }
    }

    case PaActionsEnum.GET_EXECUTIVES_FROM_PAPERS_ATTEMPT: {
      return { ...state }
    }
    case PaActionsEnum.GET_EXECUTIVES_FROM_PAPERS_SUCCESS: {
      return {
        ...state,
        executives: action.payload,
      }
    }
    case PaActionsEnum.GET_EXECUTIVES_FROM_PAPERS_FAILURE: {
      return {
        ...state,
        executives: { accountant_executives: [], customer_executives: [] },
      }
    }

    case PaActionsEnum.GET_PA_MAINTENANCE_SUCCESS: {
      return { ...state, maintenance: action.maintenance }
    }
    case PaActionsEnum.GET_PA_MAINTENANCE_FAILURE: {
      return { ...state, maintenance: null }
    }
    case PaActionsEnum.GET_PA_MAINTENANCE_ATTEMPT: {
      return { ...state, maintenance: null }
    }

    case PaActionsEnum.GET_PA_SUB_TOKEN_ATTEMPT: {
      return { ...state, sub_token_status: "loading" }
    }
    case PaActionsEnum.GET_PA_SUB_TOKEN_SUCCESS: {
      return {
        ...state,
        sub_token: action.subToken,
        sub_token_status: "success",
      }
    }
    case PaActionsEnum.GET_PA_SUB_TOKEN_FAILURE: {
      return { ...state, sub_token: null, sub_token_status: "error" }
    }

    case PaActionsEnum.CREATE_PA_SUB_TOKEN_ATTEMPT:
    case PaActionsEnum.RECREATE_PA_SUB_TOKEN_ATTEMPT: {
      return {
        ...state,
        sub_token_action_status: "loading",
        sub_token_credentials: null,
      }
    }
    case PaActionsEnum.CREATE_PA_SUB_TOKEN_SUCCESS:
    case PaActionsEnum.RECREATE_PA_SUB_TOKEN_SUCCESS: {
      return {
        ...state,
        sub_token_action_status: "success",
        sub_token_credentials: action.credentials,
        sub_token: {
          client_id: action.credentials.client_id,
          created: true,
          declared_companies_count: action.credentials.declared_companies_count,
        },
      }
    }
    case PaActionsEnum.CREATE_PA_SUB_TOKEN_FAILURE:
    case PaActionsEnum.RECREATE_PA_SUB_TOKEN_FAILURE: {
      return { ...state, sub_token_action_status: "error" }
    }
    case PaActionsEnum.CLEAR_PA_SUB_TOKEN_SECRET: {
      return { ...state, sub_token_credentials: null }
    }

    default:
      return { ...state }
  }
}

export const getFiduciaryPaFormsThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getFiduciaryPaFormsAttempt())
    return axios
      .get<PaForm[]>(`fiduciaries/${fiduciaryId}/get_pa_forms`)
      .then((response) => {
        dispatch(getFiduciaryPaFormsSuccess(response.data))
      })
      .catch((e) => {
        dispatch(getFiduciaryPaFormsFailure())
      })
  }

export const getSiretsAndCustomersOfCompanyThunk =
  (companyId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getSiretsAndCustomersOfCompanyAttempt())
    return axios
      .get<{ sirets_list: SiretInfo[]; customers: Customer[] }>(
        `companies/${companyId}/get_sirets_and_customers_of_company`
      )
      .then((response) => {
        dispatch(
          getSiretsAndCustomersOfCompanySuccess(
            response.data.sirets_list,
            response.data.customers
          )
        )
      })
      .catch((e) => {
        dispatch(getSiretsAndCustomersOfCompanyFailure())
      })
  }

export const SavePaFormThunk =
  (
    companyId: number,
    signer_accountant_user_id: number,
    signer_customer_user_id: number,
    executive_accountant_first_name: string,
    executive_accountant_last_name: string,
    executive_customer_first_name: string,
    executive_customer_last_name: string,
    suffixes: PaSuffixe[],
    routage_codes: PaCodeRoutage[],
    draft: boolean,
    pa_form_id: number | null,
    skip_mandate_creation: boolean = false,
    skip_mandate_legal_confirmation: boolean = false,
    accountant_will_sign_formal_agreement: boolean = false,
    uploaded_mandate_file_name: string | null = null,
    customer_signer_email: string | null = null
  ) =>
  (
    dispatch: Dispatch<AnyAction>
  ): Promise<{ minimalDateStart: string } | null> => {
    dispatch(SavePaFormAttempt())
    return axios
      .post(`companies/${companyId}/save_pa_form`, {
        pa_form_id: pa_form_id,
        draft: draft,
        signer_accountant_user_id: signer_accountant_user_id,
        signer_customer_user_id: signer_customer_user_id,
        suffixes: suffixes,
        routage_codes: routage_codes,
        executive_accountant_first_name: executive_accountant_first_name,
        executive_accountant_last_name: executive_accountant_last_name,
        executive_customer_first_name: executive_customer_first_name,
        executive_customer_last_name: executive_customer_last_name,
        skip_mandate_creation: skip_mandate_creation,
        skip_mandate_legal_confirmation: skip_mandate_legal_confirmation,
        accountant_will_sign_formal_agreement:
          accountant_will_sign_formal_agreement,
        uploaded_mandate_file_name: uploaded_mandate_file_name,
        customer_signer_email: customer_signer_email,
      })
      .then(() => {
        dispatch(SavePaFormSuccess(draft))
        return null
      })
      .catch((e) => {
        const data = e?.response?.data
        if (
          data?.error_code === PA_DATE_START_BEFORE_MINIMAL &&
          data?.minimal_date_start
        ) {
          dispatch(SavePaFormMinimalDateStartChanged(data.minimal_date_start))
          return { minimalDateStart: String(data.minimal_date_start) }
        }
        dispatch(SavePaFormFailure(data?.error || e.message))
        return null
      })
  }

export const resendPaSignatureRemindersThunk =
  (companyId: number, paFormId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(resendPaSignatureAttempt())
    return axios
      .post(`companies/${companyId}/resend_pa_signature_reminders`, {
        pa_form_id: paFormId,
      })
      .then(() => {
        dispatch(resendPaSignatureSuccess())
      })
      .catch((e) => {
        dispatch(
          resendPaSignatureFailure(e?.response?.data?.error || e.message)
        )
      })
  }

export const uploadPaMandateThunk =
  (companyId: number, file: File) =>
  async (): Promise<{ file_name: string } | null> => {
    try {
      const presign = await axios.get<{ put_url: string; file_name: string }>(
        `companies/${companyId}/get_pa_mandate_upload_url`
      )

      await axios.put(presign.data.put_url, file, {
        headers: { "Content-Type": "application/pdf" },
        withCredentials: false,
        transformRequest: [(data) => data],
      })

      return { file_name: presign.data.file_name }
    } catch (e) {
      return null
    }
  }

export const getPaMandateDownloadUrlThunk =
  (companyId: number) => async (): Promise<string | null> => {
    try {
      const response = await axios.get<{ get_url: string }>(
        `companies/${companyId}/get_pa_mandate_download_url`
      )
      return response.data.get_url
    } catch (e) {
      return null
    }
  }

export const downloadPaSignedDocumentsThunk =
  (companyId: number) => async (): Promise<boolean> => {
    try {
      const response = await axios.get<Blob>(
        `companies/${companyId}/download_pa_signed_documents`,
        { responseType: "blob" }
      )
      const contentDisposition = String(
        response.headers["content-disposition"] || ""
      )
      const match = contentDisposition.match(/filename="?([^"]+)"?/)
      const fileName = match ? match[1] : "documents_signes.zip"

      const blob = new Blob([response.data], { type: "application/zip" })
      const href = window.URL.createObjectURL(blob)
      const downloadElement = document.createElement("a")
      downloadElement.href = href
      downloadElement.download = fileName
      document.body.appendChild(downloadElement)
      downloadElement.click()
      downloadElement.remove()
      window.URL.revokeObjectURL(href)
      return true
    } catch (e) {
      return false
    }
  }

export const getPaFormForCompanyThunk =
  (companyId: number, options: { fromTreasurySettings?: boolean } = {}) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getPaFormForCompanyAttempt())
    return axios
      .get<{ form_for_company: FormHistory; company: CompanyWithoutPa }>(
        `companies/${companyId}/get_pa_form_for_company`,
        {
          params: {
            from_treasury_settings: options.fromTreasurySettings || false,
          },
        }
      )
      .then((response) => {
        dispatch(getPaFormForCompanySuccess(response.data))
      })
      .catch((e) => {
        dispatch(getPaFormForCompanyFailure())
      })
  }

export const getCompaniesWithoutPaThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getCompaniesWithoutPaAttempt())
    return axios
      .get<CompanyWithoutPa[]>(
        `fiduciaries/${fiduciaryId}/get_companies_without_pa`
      )
      .then((response) => {
        dispatch(getCompaniesWithoutPaSuccess(response.data))
      })
      .catch((e) => {
        dispatch(getCompaniesWithoutPaFailure())
      })
  }

export const getExecutivesFromPappersThunk =
  (companyId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getExecutivesFromPapersAttempt())
    return axios
      .get<{
        accountant_executives: Executive[]
        customer_executives: Executive[]
      }>(`companies/${companyId}/get_executives_from_pappers_for_pa`)
      .then((response) => {
        dispatch(getExecutivesFromPapersSuccess(response.data))
      })
      .catch(() => {
        dispatch(getExecutivesFromPapersFailure())
      })
  }

export const getPaMaintenanceThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getPaMaintenanceAttempt())
    return axios
      .get<PaMaintenance>(
        `fiduciaries/${fiduciaryId}/get_pa_maintenance_ongoing`
      )
      .then((response) => {
        dispatch(getPaMaintenanceSuccess(response.data))
      })
      .catch(() => {
        dispatch(getPaMaintenanceFailure())
      })
  }

export interface PaBulkResult {
  company_id: number
  success: boolean
  error: string
}

export interface PaBulkRowPayload {
  company_id: number
  signer_accountant_user_id: number | null
  signer_customer_user_id: number | null
  customer_signer_email: string | null
  executive_accountant_first_name: string
  executive_accountant_last_name: string
  executive_customer_first_name: string
  executive_customer_last_name: string
  skip_mandate_creation: boolean
  skip_mandate_legal_confirmation: boolean
  accountant_will_sign_formal_agreement: boolean
  uploaded_mandate_file_name: string | null
}

export const getCustomersForPaThunk =
  (companyId: number) => async (): Promise<Customer[]> => {
    try {
      const response = await axios.get<{
        sirets_list: SiretInfo[]
        customers: Customer[]
      }>(`companies/${companyId}/get_sirets_and_customers_of_company`)
      return response.data.customers
    } catch (e) {
      return []
    }
  }

export const getExecutivesForPaThunk =
  (companyId: number) =>
  async (): Promise<{
    accountant_executives: Executive[]
    customer_executives: Executive[]
  }> => {
    try {
      const response = await axios.get<{
        accountant_executives: Executive[]
        customer_executives: Executive[]
      }>(`companies/${companyId}/get_executives_from_pappers_for_pa`)
      return response.data
    } catch (e) {
      return { accountant_executives: [], customer_executives: [] }
    }
  }

export const createPaFormsInBulkThunk =
  (fiduciaryId: number, rows: PaBulkRowPayload[]) =>
  async (dispatch: Dispatch<AnyAction>): Promise<PaBulkResult[]> => {
    try {
      const response = await axios.post<{ results: PaBulkResult[] }>(
        `fiduciaries/${fiduciaryId}/create_pa_forms_in_bulk`,
        { rows }
      )
      const results = response.data.results
      if (results.length > 0 && results.every((r) => r.success)) {
        dispatch(createPaFormsInBulkSuccess())
      }
      return results
    } catch (e) {
      return []
    }
  }

export const getPaSubTokenThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getPaSubTokenAttempt())
    return axios
      .get<PaSubTokenStatus>(`fiduciaries/${fiduciaryId}/get_pa_sub_token`)
      .then((response) => {
        dispatch(getPaSubTokenSuccess(response.data))
      })
      .catch(() => {
        dispatch(getPaSubTokenFailure())
      })
  }

export const createPaSubTokenThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(createPaSubTokenAttempt())
    return axios
      .post<PaSubTokenCredentials>(
        `fiduciaries/${fiduciaryId}/create_pa_sub_token`
      )
      .then((response) => {
        dispatch(createPaSubTokenSuccess(response.data))
      })
      .catch(() => {
        dispatch(createPaSubTokenFailure())
      })
  }

export const recreatePaSubTokenThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(recreatePaSubTokenAttempt())
    return axios
      .post<PaSubTokenCredentials>(
        `fiduciaries/${fiduciaryId}/recreate_pa_sub_token`
      )
      .then((response) => {
        dispatch(recreatePaSubTokenSuccess(response.data))
      })
      .catch(() => {
        dispatch(recreatePaSubTokenFailure())
      })
  }
